const baseURLs = {
  local: "http://localhost:3000/api",
  web: "https://officeapi.kaaryaalaya.com/api", // Ensure HTTPS in production
};

// Notification is served from the same backend (port 3000 locally).
const notifURLs = {
  local: "http://localhost:3000",
  web: "https://officeapi.kaaryaalaya.com/",
};


// The separate student-facing site (student-frontend) -- used to build links
// that must open there, e.g. the QR-attendance scan page a student opens
// from their phone camera.
const studentPortalURLs = {
  local: "http://localhost:3001",
  web: "https://myc.kaaryaalaya.com",
};

const environment = process.env.NODE_ENV === "production" ? "web" : "local";

export const getURL = () => baseURLs[environment];

export const getNotifURL = () => notifURLs[environment];

// Uploaded files (staff/student/incident images...) only exist on the live server,
// so when running locally load them from there instead of the empty local uploads
// folder. Set REACT_APP_LOCAL_IMAGES=true to serve images from the local backend.
const imageBase = () =>
  environment === "local" && process.env.REACT_APP_LOCAL_IMAGES !== "true"
    ? baseURLs.web
    : getURL();

export const getImageURL = (url) =>
  /^(https?:|data:|blob:)/i.test(String(url || "")) ? url : `${imageBase()}${url}`;

export const getStudentPortalURL = () => studentPortalURLs[environment];

export default {
  getURL,
  getNotifURL,
  getImageURL,
  getStudentPortalURL,
};
